import {createAction} from "@reduxjs/toolkit";

export interface TicketComparePageCriteria {
  companyId?: string
  mappingId?: string
  rateModelId?: string
}

export const setTicketComparePageCriteria = createAction<TicketComparePageCriteria>("ots-ui/ticket-compare-page/setCriteria");
